import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./components/app";
import reportWebVitals from "./reportWebVitals";
import "./assets/css/index.css";
import "./utils/i18n";
import store from "./store";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RouterProvider } from "react-router";

// OneSignal Web SDK - loaded from CDN
// OneSignal service worker is auto-registered at /OneSignalSDKWorker.js
// Configure in OneSignal dashboard: Settings > Web Push > Safari (if needed)

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ToastContainer position="top-center" />
    {/* <RouterProvider router={router}> */}
    <App />
    {/* </RouterProvider> */}
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
